import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { AbadConsentStepComponent } from "../../wizard/wizard-steps/abad-consent-step/abad-consent-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class AbadConsentStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = AbadConsentStepComponent;
  }
}
